import { ref, computed, onMounted, getCurrentInstance } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

/**
 * Selector de teatro del header admin: carga los teatros disponibles del
 * usuario, excluye el actual y navega al elegido conservando el api_key.
 */
export function useAdminTeatroSelector(deps = {}) {
    const teatros = ref([]);
    const loading = ref(true);
    const navigate = deps.navigate || (url => window.location.replace(url));

    const current = computed(() => store.getters.getTeatro || null);
    const options = computed(() => {
        const currentId = current.value && current.value.id;
        return teatros.value.filter(teatro => teatro && (!currentId || teatro.id != currentId));
    });
    const hasOptions = computed(() => options.value.length > 0);

    function fetchTeatros() {
        loading.value = true;
        return store.dispatch(config.getVuexAlias('back.usuarios.teatros'), { filters: {} })
            .then(res => {
                teatros.value = (res && res.data && res.data.data) || [];
            })
            .catch(() => {
                teatros.value = [];
            })
            .then(() => {
                loading.value = false;
            });
    }

    function selectTeatro(teatro) {
        if (!teatro || !teatro.url) return;
        const token = localStorage.getItem('token');
        navigate(teatro.url + 'admin?api_key=' + token);
    }

    if (getCurrentInstance()) {
        onMounted(fetchTeatros);
    }

    return { teatros, loading, current, options, hasOptions, fetchTeatros, selectTeatro };
}
